import React from 'react';
import PropTypes from 'prop-types';
import { RedirectError } from 'four-nets/router/errors';
import { NotFoundError } from 'lib/api/api';
import { UserStore } from 'four-nets/user/user';
import { CategoryStore } from 'four-nets/forum/forum';

import LoadingProgress from 'lib/react-router/loading-progress';
import FetchData from 'lib/fetch-data/fetch-data';
import ErrorPage from 'four-nets/errors/error-page';

import ThreadMessagesView, { ThreadMessagesViewModel } from './thread-messages/thread-messages-view';
import RouteWithSearch from 'lib/react-router/route-with-search';

class ThreadMessagesLoader extends React.PureComponent {
    static contextTypes = {
        categoryStore: PropTypes.instanceOf(CategoryStore),
        urlBuilder: PropTypes.object,
        userStore: PropTypes.instanceOf(UserStore),
    };

    threadMessagesViewModel;

    transform = data => {
        const { threadViewModel } = this.props;
        const { categoryStore } = this.context;
        const {
            threadStore: { messageStore },
        } = categoryStore;

        threadViewModel.thread.messages = messageStore.processPagedJSON({
            json: data.messages,
            thread: threadViewModel.thread,
        });

        const threadMessagesViewModel = new ThreadMessagesViewModel({
            thread: threadViewModel.thread,
            urlBuilder: this.context.urlBuilder,
            mailStore: this.context.userStore.mailStore,
            newMessageViewModel: threadViewModel.newMessageViewModel,
        });

        threadMessagesViewModel.fromJSON(data.threadMessagesViewModel);

        return {
            messages: threadViewModel.thread.messages,
            threadMessagesViewModel,
        };
    };

    fetch = (setData, { page, desc }) => {
        const { threadViewModel, post } = this.props;

        return threadViewModel.thread
            .loadMessages({ page, desc })
            .then(messages => {
                const threadMessagesViewModel = new ThreadMessagesViewModel({
                    thread: threadViewModel.thread,
                    urlBuilder: this.context.urlBuilder,
                    mailStore: this.context.userStore.mailStore,
                    newMessageViewModel: threadViewModel.newMessageViewModel,
                });

                threadViewModel.firstMessageViewModel.collapse = messages.page != 1;

                threadMessagesViewModel.setDescending(desc);
                threadMessagesViewModel.scrollToId = post;

                if (
                    !this.threadMessagesViewModel ||
                    this.threadMessagesViewModel.thread.id !== threadMessagesViewModel.thread.id
                ) {
                    this.threadMessagesViewModel = threadMessagesViewModel;
                }

                setData(
                    {
                        messages,
                        threadMessagesViewModel: this.threadMessagesViewModel,
                    },
                    false
                );
            })
            .catch(error => {
                if (error instanceof NotFoundError || error.code === 404) {
                    return Promise.reject(new RedirectError(threadViewModel.thread.href));
                }
                return Promise.reject(error);
            });
    };

    renderFetch = ({ loading, error, data }) => {
        const { page = 1, desc = false, post } = this.props.search || {};

        return (
            <LoadingProgress loading={loading}>
                <ErrorPage error={error}>
                    {data ? (
                        <ThreadMessagesView
                            messages={data.messages}
                            threadMessagesViewModel={data.threadMessagesViewModel}
                            post={post}
                            page={page}
                            desc={desc}
                        />
                    ) : null}
                </ErrorPage>
            </LoadingProgress>
        );
    };

    render() {
        const { threadViewModel } = this.props;
        const { page = 1, desc = false, post } = this.props.search || {};

        return (
            <FetchData
                serializerKey={__filename}
                fetch={this.fetch}
                render={this.renderFetch}
                transform={this.transform}
                post={post}
                page={page}
                desc={desc}
                threadId={threadViewModel && threadViewModel.thread && threadViewModel.thread.id}
            />
        );
    }
}

export default (props: Props) => (
    <RouteWithSearch>
        {routeWithSearchProps => <ThreadMessagesLoader {...routeWithSearchProps} {...props} />}
    </RouteWithSearch>
);
